export default __webpack_public_path__ + "static/media/Male.54f7901a.png";